module.exports = __webpack_public_path__ + "img/nStep1.1b14d9c.svg";